import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import {
    PaymentWizardSettingsStore,
    PaymentWizardSettingsState,
} from './payment-wizard-settings.store';
import { map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PaymentWizardSettingsQuery extends Query<
    PaymentWizardSettingsState
> {
    constructor(
        protected store: PaymentWizardSettingsStore,
        private sanitizer: DomSanitizer
    ) {
        super(store);
    }

    /*-----------*/
    /** GETTERS */
    /*----------*/

    get clinicAppSchedAndBuy() {
        return this.getValue()?.clinicAppSchedAndBuy;
    }

    get productList() {
        return this.getValue()?.productList;
    }

    selectUrlPaymentSafe(): Observable<any> {
        return this.select('urlPayment').pipe(
            map((url) => {
                if (url && url !== '') {
                    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
                } else {
                    return null;
                }
            })
        );
    }
}
